export enum UserRole {
    SUPER_ADMIN = 0,
    YOUR_PLACE_STAFF = 1,
}
